
import Divider from 'vux/src/components/divider/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Loading from 'vux/src/components/loading/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import CellFormPreview from 'vux/src/components/cell-form-preview/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import CourseCard from './CourseCard'
import DueDay from '@/components/ui/DueDay'
import dateUtils from '@/modules/dateUtils'
import {getBackendHost} from './libs/misc'
import { t } from '@/modules/Translation'

export default {
  directives: {
    TransferDom
  },
  components: {
    CourseCard,
    Divider,
    Group,
    Cell,
    Loading,
    XHeader,
    CellFormPreview,
    DueDay
  },
  data () {
    return {
      homework: {},
      courseInstance: {},
      showAssignment: true,
      showComments: false,
      t: t
    }
  },
  computed: {
    title_display () {
      return this.homework.title || (this.homework.assignment ? this.homework.assignment.slice(0, 100) : '')
    },
    hasComments () {
      return this.homework.comments !== '' && this.homework.comments !== undefined
    },
    createDate () {
      return dateUtils.format(this.homework.create_date)
    },
    dueDate () {
      return dateUtils.format(this.homework.due_date)
    },
    isOverdue () {
      return dateUtils.isOverdue(this.homework.due_date)
    },
    hasAttachment () {
      return this.homework.attachment_name && true
    },
    attachmentLink () {
      return this.homework.attachment_url
        ? getBackendHost(window.location) + this.homework.attachment_url
        : getBackendHost(window.location) + `/downloads/homework/${this.homework.homework_id}/attachment?token=${this.homework.attachment_token}`
    }
  },
  methods: {
    dueSoon: dateUtils.dueSoon
  },
  created () {
    this.$store.dispatch('load', ['allCourses', 'todoHomeworks'])
      .then(() => {
        this.homework = this.$store.state.todoHomeworks.find(
          hw => (hw.id + '') === this.$route.params.id)

        this.courseInstance = this.$store.getters.keyedCourses[this.homework.course_instance_id]

        this.$vux.loading.hide()
      })
  },
  mounted () {
    this.$vux.loading.show()
  }
}



// WEBPACK FOOTER //
// ./src/components/Homework.vue